import { render, staticRenderFns } from "./_teacherId.vue?vue&type=template&id=03b29a13&scoped=true&"
import script from "./_teacherId.vue?vue&type=script&lang=js&"
export * from "./_teacherId.vue?vue&type=script&lang=js&"
import style0 from "./_teacherId.vue?vue&type=style&index=0&id=03b29a13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b29a13",
  null
  
)

export default component.exports